module.exports = __webpack_public_path__ + "static/img/circle_icon_wu.545d3b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/circle_icon_wu.png
// module id = XUnv
// module chunks = 1